import React, { createContext, useState, useCallback } from 'react';
import Modal from '../components/common/Modal/Modal';

export const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [config, setConfig] = useState(null);

  const showModal = useCallback((options) => {
    setConfig({ ...options, show: true });
  }, []);

  const hideModal = useCallback(() => setConfig(null), []);

  const handleConfirm = async () => {
    // Fecha o modal atual antes de executar a ação de confirmação.
    // Isso permite que a ação de confirmação abra um novo modal
    // (por exemplo, para exibir a nova senha gerada) sem que ele
    // seja fechado automaticamente em seguida.
    const onConfirm = config?.onConfirm;
    hideModal();
    if (onConfirm) {
      await onConfirm();
    }
  };

  const handleCancel = () => {
    if (config?.onCancel) config.onCancel();
    hideModal();
  };

  return (
    <ModalContext.Provider value={{ showModal, hideModal }}>
      {children}
      {config && (
        <Modal
          show={config.show}
          title={config.title}
          message={config.message}
          body={config.body}
          confirmText={config.confirmText}
          cancelText={config.cancelText}
          onConfirm={handleConfirm}
          onCancel={config.cancelText ? handleCancel : undefined}
          className={config.className || config?.modalProps?.className}
          closeOnOverlayClick={config?.modalProps?.closeOnOverlayClick}
        />
      )}
    </ModalContext.Provider>
  );
};
